import taskModalImage from '../../assets/images/premium-locked-screen/shift-tasks/task-modal-with-shadow.svg';
import shiftModalImage from '../../assets/images/premium-locked-screen/shift-tasks/shift-modal.svg';
import mobileTaskImage from '../../assets/images/premium-locked-screen/shift-tasks/mobile-task.svg';
import taskListImage from '../../assets/images/premium-locked-screen/shift-tasks/task-list.svg';
import { PREMIUM_FEATURE_NAMES } from '../../../src/constants';

import shiftTasksPreviewUrl from './shiftTasksPreview.html';

class ShiftTasksPreviewCtrl {
  taskModalImage = taskModalImage;
  shiftModalImage = shiftModalImage;
  mobileTaskImage = mobileTaskImage;
  taskListImage = taskListImage;
  SHIFT_TASKS_FEATURE_NAME = PREMIUM_FEATURE_NAMES.shiftTasks;

  constructor(Authentication, SlingAnalytics) {
    'ngInject';

    Object.assign(this, { Authentication, SlingAnalytics });
  }

  trackInterest() {
    this.SlingAnalytics.track(this.SlingAnalytics.shiftTaskPageLedToPremiumPricing);
  }
}

export default {
  controller: ShiftTasksPreviewCtrl,
  controllerAs: 'ctrl',
  templateUrl: shiftTasksPreviewUrl,
};
